var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12609_42479)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C18.623 0 24 5.37703 24 12C24 18.623 18.623 24 12 24C5.37703 24 0 18.623 0 12C0 5.37703 5.37703 0 12 0ZM19.1866 8.38959C19.0141 7.74417 18.5059 7.236 17.8605 7.0635C16.6906 6.75 12 6.75 12 6.75C12 6.75 7.30936 6.75 6.13945 7.0635C5.49422 7.236 4.98586 7.74417 4.81336 8.38959C4.5 9.55936 4.5 12.0001 4.5 12.0001C4.5 12.0001 4.5 14.4407 4.81336 15.6104C4.98586 16.2558 5.49422 16.7642 6.13945 16.9366C7.30936 17.25 12 17.25 12 17.25C12 17.25 16.6906 17.25 17.8605 16.9366C18.5059 16.7642 19.0141 16.2558 19.1866 15.6104C19.5 14.4407 19.5 12.0001 19.5 12.0001C19.5 12.0001 19.5 9.55936 19.1866 8.38959ZM10.5 14.2501V9.75005L14.397 12.0001L10.5 14.2501Z",
    fill: "#2D2D2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12609_42479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.bae493045c23cd39a316300903f82da2.svg";
export { ForwardRef as ReactComponent };